(() => {
  'use strict';
  if (window.__PW_GRID_QUANTITY_V2__) return;
  window.__PW_GRID_QUANTITY_V2__ = true;

  const rootUrl = window.Shopify?.routes?.root || '/';
  const selector = '.pw-product-card at-add-to-cart[data-pw-grid-static][data-available="true"] > .js-add-to-cart';

  function normalize(control, rawValue) {
    const input = control.querySelector('[data-pw-grid-qty-input]');
    if (!input) return 1;
    const min = Math.max(1, Math.floor(Number(control.dataset.pwMin) || 1));
    const max = Math.max(min, Math.floor(Number(control.dataset.pwMax) || 999));
    const increment = Math.max(1, Math.floor(Number(control.dataset.pwStep) || 1));
    const raw = Number(rawValue);
    const clamped = Number.isFinite(raw) ? Math.min(max, Math.max(min, raw)) : min;
    const steps = Math.max(0, Math.floor((clamped - min) / increment));
    const selected = min + steps * increment;
    input.value = String(selected);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    return selected;
  }

  async function addSelected(component, button) {
    if (component.dataset.pwAdding === 'true') return;
    const variantId = Number(component.dataset.variantId);
    if (!Number.isInteger(variantId) || variantId <= 0) return;
    const control = component.querySelector('[data-pw-grid-qty-control]');
    const input = control?.querySelector('[data-pw-grid-qty-input]');
    const quantity = control && input ? normalize(control, input.value) : 1;
    component.dataset.pwAdding = 'true';
    component.classList.add('pw-is-adding');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity }],
          sections: ['cart-ajax'],
          sections_url: location.pathname
        })
      });
      const result = await response.json().catch(() => ({}));
      if (!response.ok) throw result;
      if (!result.sections?.['cart-ajax']) {
        const sectionResponse = await fetch(rootUrl + '?section_id=cart-ajax', {
          credentials: 'same-origin',
          headers: { Accept: 'text/html' }
        });
        if (sectionResponse.ok) {
          result.sections = result.sections || {};
          result.sections['cart-ajax'] = await sectionResponse.text();
        }
      }
      component.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        bubbles: true,
        detail: { product: result, preventCartOpen: false }
      }));
    } catch (error) {
      if (error?.name === 'PWCompatibilityCancelled') return;
      const message = error?.description || error?.message || 'Unable to add this product. Please try again.';
      window.alert(message);
    } finally {
      delete component.dataset.pwAdding;
      component.classList.remove('pw-is-adding');
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.setAttribute('aria-expanded', 'false');
    }
  }

  document.addEventListener('click', event => {
    const stepperButton = event.target.closest('[data-pw-grid-minus],[data-pw-grid-plus]');
    if (stepperButton) {
      const control = stepperButton.closest('.pw-product-card [data-pw-grid-qty-control]');
      if (!control) return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      const input = control.querySelector('[data-pw-grid-qty-input]');
      const increment = Math.max(1, Math.floor(Number(control.dataset.pwStep) || 1));
      normalize(control, Number(input?.value || control.dataset.pwMin) +
        (stepperButton.hasAttribute('data-pw-grid-plus') ? increment : -increment));
      return;
    }
    const button = event.target.closest(selector);
    if (!button) return;
    const component = button.closest('at-add-to-cart');
    if (!component || component.dataset.available !== 'true') return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    addSelected(component, button);
  }, true);

  document.addEventListener('change', event => {
    if (!event.target.matches('.pw-product-card [data-pw-grid-qty-input]')) return;
    const control = event.target.closest('[data-pw-grid-qty-control]');
    if (control) normalize(control, event.target.value);
  }, true);

})();